export enum EFeatureFlags {
  MAINTENANCE_MODE = 'maintenance_mode',
  FORCE_FP_OLD_USERS_MATRICULATION_MODAL = 'force_fp_old_users_matriculation_modal'
}
